// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";

const metadata: BuiltInScriptMetadata = {
  name: "Grapple Swing",
  id: "grapple-swing",
  metadata: {
    imports: ["grapple", "aim", "wait", "self"],
    icon: {
      backgroundColor: 3607634,
      layers: [
        {
          iconKey: "grapple",
          position: {
            x: 0,
            y: 0
          },
          scale: 0.95,
          rotation: 11,
          color: 16740810
        },
        {
          iconKey: "aim",
          position: {
            x: 15,
            y: -1
          },
          scale: 0.59,
          rotation: -8,
          color: 16777215
        },
        {
          iconKey: "delay",
          position: {
            x: -15,
            y: -4
          },
          scale: 0.67,
          rotation: 16,
          color: 16771071
        }
      ]
    }
  }
};

export default metadata;
